// extracted by mini-css-extract-plugin
export default {"footer-grid":"Footer_footer-grid__ptuXJ","grid-item":"Footer_grid-item__b9t0E","left-link":"Footer_left-link__CCS03","right-link":"Footer_right-link__PjbI4"};